import clsx from 'clsx'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

/*
 * Symbole vor den Handlungen zu einem Datensatz — im Drei-Punkte-Menü der
 * Liste (`UI/BtnTooltip`) und im Reiter „Handlungen" des Profilfensters.
 *
 * Bewusst als Linienzeichnung mit `currentColor`: Das Symbol nimmt die Farbe
 * seiner Beschriftung an — „Konto löschen" wird mit ihr rot, ein gesperrter
 * Eintrag mit ihr grau, ohne dass jemand eine zweite Farbe pflegen muss.
 *
 * Die Breite ist fest (`flex: 0 0 …`): Das globale `svg { flex: 1 1 0% }`
 * zöge das Symbol sonst in einer Flex-Zeile auseinander.
 */
const PATHS = {
	// Ansichtsmodus: durch die Augen einer anderen Rolle sehen.
	eye: (
		<>
			<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
			<circle cx="12" cy="12" r="3" />
		</>
	),
	user: (
		<>
			<circle cx="12" cy="8" r="4" />
			<path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
		</>
	),
	userEdit: (
		<>
			<circle cx="10" cy="8" r="4" />
			<path d="M3 21c0-4 3.1-7 7-7 1.3 0 2.5.3 3.5.9" />
			<path d="M18.4 13.6a1.9 1.9 0 0 1 2.7 2.7L16 21.4l-3.4.8.8-3.4z" />
		</>
	),
	download: (
		<>
			<path d="M12 3v12" />
			<path d="M7 10l5 5 5-5" />
			<path d="M4 21h16" />
		</>
	),
	documentCheck: (
		<>
			<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
			<path d="M14 3v5h5" />
			<path d="M9 14.5l2 2 4-4" />
		</>
	),
	badgeCheck: (
		<>
			<path d="M12 2l2.4 1.8 3-.2.9 2.9 2.5 1.7-1 2.8 1 2.8-2.5 1.7-.9 2.9-3-.2L12 22l-2.4-1.8-3 .2-.9-2.9-2.5-1.7 1-2.8-1-2.8 2.5-1.7.9-2.9 3 .2z" />
			<path d="M8.5 12l2.5 2.5 4.5-4.5" />
		</>
	),
	merge: (
		<>
			<circle cx="6" cy="5" r="2" />
			<circle cx="6" cy="19" r="2" />
			<circle cx="18" cy="12" r="2" />
			<path d="M6 7v10" />
			<path d="M6 8c0 3 3 4 10 4" />
		</>
	),
	trash: (
		<>
			<path d="M4 7h16" />
			<path d="M10 11v6M14 11v6" />
			<path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12" />
			<path d="M9 7V4h6v3" />
		</>
	)
}

export const ACTION_ICONS = Object.keys(PATHS)

export default function ActionIcon({ name, size, className }) {
	const paths = PATHS[name]
	if (!paths) return null

	return (
		<svg
			className={clsx(styles.root, className)}
			style={{ width: size, height: size, flexBasis: size }}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			focusable="false"
		>
			{paths}
		</svg>
	)
}

ActionIcon.propTypes = {
	name: PropTypes.oneOf(ACTION_ICONS).isRequired,
	size: PropTypes.number,
	className: PropTypes.string
}

ActionIcon.defaultProps = {
	size: 18,
	className: ''
}
